/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getStockModuleSetting,
  updateStockModuleSetting,
} from "modules/account/redux";
import StockModuleSettingPanelComponent from "./stockModuleSettingPanel.component";
import { useHistory } from "react-router-dom";
import {AccessRights} from "lib/constants/accessRights";
import { DASHBOARD } from "modules/dashboard/constants";
import { getLang } from "app/feature/constants";
import { addAlert, selectLoading } from "modules/notification";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

export default function StockModuleSettingPanelContainer() {
  const dispatch = useDispatch();
  const history = useHistory;

  const lang = useSelector((state) => state.constant.languages);
  const hasCompanyStockViewAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Company.STOCK_MODULE_READ));
  const hasCompanyStockEditAccessRight = useSelector((state) =>
    canAccess(state, AccessRights.Company.STOCK_MODULE_WRITE));
  const canEditEmailSettings = useSelector((state) =>
    canAccess(state, AccessRights.Company.STOCK_MODULE_WRITE_EMAIL_SETTINGS));
  const canEditDealerStockflow = useSelector((state) =>
    canAccess(state, AccessRights.Company.STOCK_MODULE_WRITE_DEALER_STOCKFLOW));
  const canEditDealerIncentivePoints = useSelector((state) =>
    canAccess(state, AccessRights.Company.STOCK_MODULE_WRITE_DEALER_INCENTIVE_POINTS));
  const canEditBranchStockflow = useSelector((state) =>
    canAccess(state, AccessRights.Company.STOCK_MODULE_WRITE_BRANCH_STOCKFLOW));


  const isLoadingStockModuleSetting = useSelector((state) =>
    selectLoading(state, getStockModuleSetting.typePrefix)
  );
  const isSubmitting = useSelector((state) =>
    selectLoading(state, updateStockModuleSetting.typePrefix)
  );

  const rules = useSelector((state) => state.stockModuleSetting.rules);

  const [reasonActiveIndex, setReasonActiveIndex] = useState(0);
  const [hasEmptyReasonField, setHasEmptyReasonField] = useState([]);
  const [invalidEmails, setInvalidEmails] = useState([]);

  const tabLabels = {
    0: {
      value: "Receive Transfer",
      label: getLang(lang, "label.RECEIVE_TRANSFER"),
    },
  };

  useEffect(() => {
    if (hasCompanyStockViewAccessRight) {
      dispatch(getStockModuleSetting());
    } else {
      history.push(DASHBOARD);
    }
  }, [history, dispatch, hasCompanyStockViewAccessRight]);

  const handleSubmit = (values) => {
    let params = {
      maxTier: values.maxTier,
      requestStock: values.requestStock,
      checkRequestStockQuantity: values.checkRequestStockQuantity,
      autoReceiveStock: values.autoReceiveStock,
      autoReceiveStockDays: values.autoReceiveStockDays,
      rewardPoint: values.rewardPoint,
      rewardPointMin: values.rewardPointMin,
      rewardPointExpiration: values.rewardPointExpiration,
      rewardPointExpirationMonths: values.rewardPointExpirationMonths,
      rewardPointRecallDeduction: values.rewardPointRecallDeduction,
    };
    if (canEditBranchStockflow) {
      let autoReceiveSelection = values.enableAutoCompleteTransfer;
      if (autoReceiveSelection > 0) {
        autoReceiveSelection = values.actionAfterAutoCompleteTransfer;
      }
      params.autoReceiveTransfer = autoReceiveSelection;
      params.autoReceiveTransferDays = values.autoReceiveTransferDays;
      params.enableTransferRules = values.enableTransferRules;
      params.enableCustomReasons = values.enableCustomReasons;

      if (values.reasons && !!values.enableCustomReasons) {
        let data = [];
        let valid = true;

        Object.keys(values.reasons).forEach((rKey) => {
          let reasonData = values.reasons[rKey];

          const reasonByLang = {};

          for (const reason of reasonData.reasons) {
            for (const used of reasonData.usedLang) {
              reasonByLang[used.code] = reasonByLang[used.code]
                ? [...reasonByLang[used.code], reason.name[used.code]]
                : [reason.name[used.code]];
            }
          }

          let tempHasEmptyReasonField = [];
          for (const key in reasonByLang) {
            if (
              reasonByLang[key].filter((r) => !!r).length !==
              reasonData.reasons.length
            ) {
              valid = false;
              tempHasEmptyReasonField.push(rKey);
            }
          }
          setHasEmptyReasonField(tempHasEmptyReasonField);

          data.push({
            type: rKey,
            data: values.reasons[rKey].reasons,
          });
        });

        if (!valid) {
          return;
        }
        params.customReasons = data;
      } else {
        params.customReasons = [];
      }
    }

    if (canEditEmailSettings) {
      params.customEmailOption = values.emailSettings;
      params.customEmailRecipients = values.emailRecipients.filter(
        (r) => !!r.trim()
      );
    }

    params.hasCompanyStockEditTransferAccessRight =
      canEditBranchStockflow;
    params.hasUpdateReceiveEmailAccessRight = canEditEmailSettings;

    dispatch(updateStockModuleSetting(params));
  };

  const showAlert = (message) => {
    dispatch(
      addAlert({
        severity: "error",
        message: message,
      })
    );
  };

  return (
    <StockModuleSettingPanelComponent
      isEditable={hasCompanyStockEditAccessRight}
      canEditEmailSettings={canEditEmailSettings}
      canEditDealerStockflow={canEditDealerStockflow}
      canEditDealerIncentivePoints={canEditDealerIncentivePoints}
      canEditBranchStockflow={canEditBranchStockflow}
      isLoadingStockModuleSetting={isLoadingStockModuleSetting}
      rules={rules}
      handleSubmit={handleSubmit}
      lang={lang}
      tabLabels={tabLabels}
      reasonActiveIndex={reasonActiveIndex}
      changeTab={(e, val) => setReasonActiveIndex(val)}
      hasEmptyReasonField={hasEmptyReasonField}
      isSubmitting={isSubmitting}
      setInvalidEmails={setInvalidEmails}
      invalidEmails={invalidEmails}
      showAlert={showAlert}
    />
  );
}
